/**
 * @description Subscriber package values from Smart Tag paramsVO.USER.userStatus pattern key|value
 */
export enum SubscriberPackageValue {
	VALUE_0 = '0',
	VALUE_6 = '6',
	VALUE_14 = '14',
	VALUE_15 = '15',
	VALUE_17 = '17',
	VALUE_18 = '18',
	VALUE_22 = '22',
	VALUE_23 = '23',
	VALUE_24 = '24',
	VALUE_25 = '25',
	EMPTY = ''
}